/* eslint-disable import/prefer-default-export */
export const getUserAuthStatus = (store) => store.auth.user.group;
export const getUserTaxStatus = (store) => store.auth.user.taxStatus.status;
